import * as React from 'react';
import { Field } from 'redux-form';
import {
  Col,
  ControlLabel,
  OverlayTrigger,
  Popover,
  Row,
} from 'react-bootstrap';
import { isRequired } from '../../../../../../util/validators';
import { II18nMessages } from '../../../../../../services/branding/models';
import SelectControl from '../../../../../../components/SelectControl';
import * as Commonmark from 'react-commonmark';
import FaInfoCircle from 'react-icons/fa/info-circle';

interface ITripDetailsForm {
  i18n: II18nMessages;
  options: any;
  definition?: any;
  withPopover?: boolean;
  renderDefinition?: any;
  isInvalid?: boolean;
}

class MaxTripDuration extends React.Component<ITripDetailsForm> {
  public render() {
    const {
      i18n,
      options,
      definition,
      withPopover,
      renderDefinition,
    } = this.props;
    const infoIcon = (
      <Popover id="popover-trigger-click-root-close" title="Max Trip Duration">
        <Commonmark source={definition} />
      </Popover>
    );
    const classname = [withPopover ? '' : 'no-wrap'].join(' ');

    return (
      <Row>
        <Col sm={3}>
          <ControlLabel>
            <div className={classname}>
              {i18n.quote.tripDetails.maxTripDuration}
              {withPopover ? (
                <OverlayTrigger
                  trigger="click"
                  rootClose={true}
                  placement="right"
                  overlay={infoIcon}
                >
                  <FaInfoCircle />
                </OverlayTrigger>
              ) : (
                renderDefinition('max_trip_duration')
              )}
            </div>
          </ControlLabel>
        </Col>
        <Col sm={9}>
          <Field
            isInvalid={this.props.isInvalid}
            name="maxTripDuration"
            id="region-select"
            type="text"
            component={SelectControl}
            options={options}
            validate={[isRequired]}
          />
        </Col>
      </Row>
    );
  }
}

export default MaxTripDuration;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/components/MaxTripDuration/MaxTripDuration.tsx